// Systeemkeuze Simply Offgrid: vragen en uitkomst. De rekenmotor staat in so-systeemkeuze-engine.js,
// de rekenwaarden in so-systeemkeuze-config.js (bron: simplysolarOS). Geen Alpine, geen afhankelijkheden.
(function () {
  const root = document.querySelector('[data-so-sk]');
  if (!root || !window.SOSysteemkeuze || !window.SOSysteemkeuzeConfig) return;
  const C = window.SOSysteemkeuzeConfig;
  const OPSLAG = 'so-sk-antwoorden';
  const el = (sel) => root.querySelector(sel);
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const meet = (naam, data) => { try { window.Shopify && Shopify.analytics && Shopify.analytics.publish(naam, data || {}); } catch (e) { /* meten mag nooit de calculator breken */ } };

  // Antwoorden blijven 7 dagen in deze browser bewaard (localStorage), zodat "Terug naar je advies"
  // ook werkt vanuit een nieuw tabblad. Niets gaat naar een server tot iemand advies aanvraagt.
  const BEWAARTIJD = 7 * 24 * 3600 * 1000;
  let a = { land: root.dataset.land === 'BE' ? 'BE' : 'NL', doelen: [], zwareVerbruikers: [] };
  try {
    const opgeslagen = JSON.parse(localStorage.getItem(OPSLAG) || 'null');
    if (opgeslagen && opgeslagen.a && Date.now() - opgeslagen.t < BEWAARTIJD) a = opgeslagen.a;
  } catch (e) { /* geen opslag */ }
  const bewaar = () => { try { localStorage.setItem(OPSLAG, JSON.stringify({ t: Date.now(), a })); } catch (e) { /* geen opslag */ } };
  let sets = {};
  try { sets = JSON.parse((root.parentElement.parentElement.querySelector('[data-so-sk-sets]') || document.querySelector('[data-so-sk-sets]')).textContent); } catch (e) { /* geen productgegevens */ }

  const isSolar = () => a.situatie === 'solar-net' || a.situatie === 'solar-offgrid';
  const isOffgrid = () => a.situatie === 'solar-offgrid';

  // Vragen in volgorde. `toon` bepaalt of de vraag past bij de antwoorden tot nu toe.
  const VRAGEN = [
    { id: 'situatie', titel: 'Wat is je situatie?', soort: 'kaart', opties: [
      { w: 'ess', t: 'Ik heb al zonnepanelen', s: 'Ik wil er een thuisbatterij bij: opslag en noodstroom.' },
      { w: 'solar-net', t: 'Ik wil panelen en opslag', s: 'Voor een woning met een netaansluiting.' },
      { w: 'solar-offgrid', t: 'Ik heb geen (sterk genoeg) net', s: 'Chalet, tiny house of woning die zelfstandig draait.' },
    ] },
    { id: 'gewest', titel: 'In welk gewest woon je?', soort: 'kaart', toon: () => a.land === 'BE', opties: [
      { w: 'Vlaanderen', t: 'Vlaanderen' }, { w: 'Wallonië', t: 'Wallonië' }, { w: 'Brussel', t: 'Brussel' },
    ] },
    { id: 'fase', titel: 'Heb je een 1-fase of 3-fase aansluiting?', hulp: 'Kijk in de meterkast: drie hoofdschakelaars naast elkaar, of één brede, betekent 3-fase.', soort: 'kaart', toon: () => !isOffgrid(), opties: [
      { w: '1', t: '1-fase' }, { w: '3', t: '3-fase' }, { w: null, t: 'Weet ik niet' },
    ] },
    { id: 'woningType', titel: 'Wat voor plek is het?', soort: 'kaart', toon: isOffgrid, opties: [
      { w: 'tiny', t: 'Tiny house of tuinhuis' }, { w: 'chalet', t: 'Chalet of vakantiewoning' }, { w: 'woning', t: 'Woning, het hele jaar' },
    ] },
    { id: 'doelen', titel: 'Wat wil je bereiken?', hulp: 'Meer antwoorden kan.', soort: 'multi', toon: () => !isOffgrid(), opties: [
      { w: 'noodstroom', t: 'Stroom bij een storing' }, { w: 'zelfverbruik', t: 'Meer eigen zonnestroom gebruiken' }, { w: 'dynamisch', t: 'Slim laden met een dynamisch contract' },
    ] },
    { id: 'noodstroom', titel: 'Wat moet er blijven werken bij een storing?', soort: 'kaart', toon: () => !isOffgrid(), opties: [
      { w: 'alles', t: 'Het hele huis' }, { w: 'groepen', t: 'Een paar groepen', s: 'Bijvoorbeeld koelkast, verwarming en internet.' }, { w: 'nee', t: 'Niet belangrijk' },
    ] },
    { id: 'ampere', titel: 'Hoeveel ampère is je hoofdzekering?', hulp: 'Staat op de hoofdschakelaar of het contract. Bepaalt hoeveel stroom door de omvormer moet als het hele huis op de noodstroom staat.', soort: 'kaart',
      toon: () => a.noodstroom === 'alles' && !isOffgrid(), opties: [
      { w: 25, t: '25 A' }, { w: 35, t: '35 A' }, { w: 40, t: '40 A of meer' }, { w: null, t: 'Weet ik niet' },
    ] },
    { id: 'zwareVerbruikers', titel: 'Welke zware verbruikers heb je?', hulp: 'Meer antwoorden kan.', soort: 'multi', opties: [
      { w: 'warmtepomp', t: 'Warmtepomp' }, { w: 'laadpaal', t: 'Laadpaal' }, { w: 'inductie', t: 'Inductie koken' }, { w: 'boiler', t: 'Elektrische boiler' }, { w: 'airco', t: 'Airco' },
    ] },
    { id: 'verbruik', titel: 'Hoeveel stroom gebruik je?', hulp: 'Je jaarverbruik staat op je energierekening. Weet je het niet, laat het dan leeg: we schatten het.', soort: 'verbruik' },
    { id: 'pv', titel: 'Over je bestaande panelen', hulp: 'Het vermogen van je omvormer staat op het typeplaatje (bijvoorbeeld SE5K = 5 kW). Laat leeg als je het niet weet.', soort: 'pv', toon: () => a.situatie === 'ess' },
    { id: 'dak', titel: 'Over je dak', soort: 'dak', toon: isSolar },
    { id: 'accuPlek', titel: 'Waar komt de accu?', soort: 'kaart', opties: [
      { w: 'binnen', t: 'Binnen, in een droge ruimte' }, { w: 'schuur', t: 'In een schuur of garage' }, { w: 'trap-kelder', t: 'Via een trap of in de kelder' },
    ] },
    { id: 'installatie', titel: 'Installeer je zelf?', hulp: 'Onze sets zijn gemaakt om zelf te installeren, met schema en handleiding. In een deel van Nederland en België kunnen we het ook voor je doen.', soort: 'installatie' },
  ];

  const zichtbaar = () => VRAGEN.filter((v) => !v.toon || v.toon());
  let stap = 0;

  function knop(v, o) {
    const actief = v.soort === 'multi' ? (a[v.id] || []).includes(o.w) : a[v.id] === o.w && (o.w !== null || v.id in a);
    return '<button type="button" class="so-sk__optie' + (actief ? ' is-actief' : '') + '" data-w="' + esc(JSON.stringify(o.w)) + '">' +
      '<span class="so-sk__optie-t">' + esc(o.t) + '</span>' + (o.s ? '<span class="so-sk__optie-s">' + esc(o.s) + '</span>' : '') + '</button>';
  }

  function veld(id, label, waarde, extra) {
    return '<label class="so-sk__veld"><span>' + esc(label) + '</span><input type="number" inputmode="numeric" min="0" data-veld="' + id + '" value="' + (waarde ?? '') + '" ' + (extra || '') + '></label>';
  }

  function renderVraag() {
    const lijst = zichtbaar();
    stap = Math.max(0, Math.min(stap, lijst.length - 1));
    const v = lijst[stap];
    let body = '';
    if (v.soort === 'kaart' || v.soort === 'multi') {
      body = '<div class="so-sk__opties">' + v.opties.map((o) => knop(v, o)).join('') + '</div>';
    } else if (v.soort === 'verbruik') {
      body = veld('jaarverbruikKwh', 'Jaarverbruik in kWh', a.jaarverbruikKwh, 'placeholder="bijv. 3500"') +
        '<p class="so-sk__of">of</p>' + veld('verbruikEuroMaand', 'Ongeveer per maand aan stroom (€)', a.verbruikEuroMaand, 'placeholder="bijv. 90"');
      if (!isOffgrid()) {
        body += '<p class="so-sk__of">of kies</p><div class="so-sk__opties so-sk__opties--klein">' +
          [{ w: 'klein', t: '1–2 personen' }, { w: 'gemiddeld', t: '3–4 personen' }, { w: 'groot', t: '5 of meer' }]
            .map((o) => '<button type="button" class="so-sk__optie' + (a.huishouden === o.w ? ' is-actief' : '') + '" data-huishouden="' + o.w + '"><span class="so-sk__optie-t">' + o.t + '</span></button>').join('') + '</div>';
      }
    } else if (v.soort === 'pv') {
      body = veld('bestaandePvKw', 'Vermogen van je PV-omvormer (kW)', a.bestaandePvKw, 'step="0.1" placeholder="bijv. 5"') +
        '<p class="so-sk__label">Is je PV-omvormer 1-fase of 3-fase?</p><div class="so-sk__opties so-sk__opties--klein">' +
        [{ w: '1', t: '1-fase' }, { w: '3', t: '3-fase' }, { w: '', t: 'Weet ik niet' }]
          .map((o) => '<button type="button" class="so-sk__optie' + ((a.bestaandePvFase || '') === o.w ? ' is-actief' : '') + '" data-pvfase="' + o.w + '"><span class="so-sk__optie-t">' + o.t + '</span></button>').join('') + '</div>';
    } else if (v.soort === 'dak') {
      body = veld('dakPanelenMax', 'Hoeveel panelen passen er (ongeveer)?', a.dakPanelenMax, 'placeholder="laat leeg als je het niet weet"') +
        '<p class="so-sk__label">Waar liggen ze?</p><div class="so-sk__opties so-sk__opties--klein">' +
        [{ w: 'zuid', t: 'Zuid' }, { w: 'oost-west', t: 'Oost/west' }, { w: 'noord', t: 'Noord' }]
          .map((o) => '<button type="button" class="so-sk__optie' + ((a.orientatie || 'zuid') === o.w ? ' is-actief' : '') + '" data-orientatie="' + o.w + '"><span class="so-sk__optie-t">' + o.t + '</span></button>').join('') + '</div>' +
        (a.situatie === 'solar-net' ? '<label class="so-sk__check"><input type="checkbox" data-check="aggregaat"' + (a.aggregaat ? ' checked' : '') + '> Ik wil ook een aggregaat aansluiten</label>' : '');
    } else if (v.soort === 'installatie') {
      body = '<label class="so-sk__check"><input type="checkbox" data-check="installatie"' + (a.installatie ? ' checked' : '') + '> Ik wil weten of jullie het kunnen installeren</label>' +
        (a.installatie ? '<label class="so-sk__veld"><span>Postcode</span><input type="text" data-tekst="postcode" value="' + esc(a.postcode || '') + '" placeholder="bijv. 2514 AB"></label>' : '');
    }
    const laatste = stap === lijst.length - 1;
    const verplicht = v.soort === 'kaart' && v.id !== 'ampere' && v.id !== 'fase' && !(v.id in a);
    el('[data-stap]').innerHTML =
      '<div class="so-sk__voortgang" aria-hidden="true"><span style="width:' + Math.round(((stap + 1) / lijst.length) * 100) + '%"></span></div>' +
      '<p class="so-sk__teller">Vraag ' + (stap + 1) + ' van ' + lijst.length + '</p>' +
      '<h2 class="so-sk__vraag">' + esc(v.titel) + '</h2>' + (v.hulp ? '<p class="so-sk__hulp">' + esc(v.hulp) + '</p>' : '') + body +
      '<div class="so-sk__nav">' + (stap > 0 ? '<button type="button" class="so-sk__terug" data-actie="terug">Terug</button>' : '<span></span>') +
      '<button type="button" class="button so-sk__verder" data-actie="' + (laatste ? 'advies' : 'verder') + '"' + (verplicht ? ' disabled' : '') + '>' + (laatste ? 'Bekijk mijn advies' : 'Verder') + '</button></div>';
    el('[data-uitkomst]').hidden = true;
    el('[data-stap]').hidden = false;
    meet('so_systeemkeuze_vraag', { vraag: v.id, stap: stap + 1 });
  }

  function lijstHtml(titel, items, cls) {
    if (!items || !items.length) return '';
    return '<div class="so-sk__blok ' + (cls || '') + '"><h3>' + esc(titel) + '</h3><ul>' + items.map((x) => '<li>' + esc(x) + '</li>').join('') + '</ul></div>';
  }

  function renderUitkomst() {
    const r = window.SOSysteemkeuze.advies(a, C);
    const c = r.config;
    const maatwerk = r.status === 'maatwerk';
    const regels = [
      c.omvormer && ['Omvormer', c.omvormer.label],
      c.accu && ['Accu', c.accu.naam + ', ' + c.accu.modules + (c.accu.modules === 1 ? ' module' : ' modules') + ' (' + String(c.accu.kwhNominaal).replace('.', ',') + ' kWh; in de praktijk ongeveer ' + String(c.accu.kwhPraktijk).replace('.', ',') + ' kWh bruikbaar)'],
      c.panelen && ['Zonnepanelen', c.panelen.aantal + ' × ' + c.panelen.wp + ' Wp (' + String(c.panelen.kwp).replace('.', ',') + ' kWp)'],
    ].filter(Boolean);
    let html = '<p class="so-sk__teller">' + (maatwerk ? 'Dit rekenen we liever samen door' : 'Ons advies') + '</p>' +
      '<h2 class="so-sk__vraag">' + esc(r.set.naam) + '</h2>' +
      '<dl class="so-sk__config">' + regels.map(([k, v]) => '<dt>' + k + '</dt><dd>' + esc(v) + '</dd>').join('') + '</dl>';
    const p = sets[r.set.key];
    if (p && p.titel && !maatwerk) {
      html += '<a class="so-sk__product" href="' + esc(r.productUrl) + '" data-actie="naar-set">' +
        (p.beeld ? '<img src="' + esc(p.beeld) + '" alt="" loading="lazy" width="120" height="120">' : '') +
        '<span class="so-sk__product-tekst"><span class="so-sk__product-titel">' + esc(p.titel) + '</span>' +
        '<span class="so-sk__product-sub">Met jouw keuzes alvast ingevuld</span><span class="so-sk__product-link">Bekijk deze set →</span></span></a>';
    }
    if (maatwerk) html += lijstHtml('Waarom persoonlijk advies', r.maatwerkRedenen, 'so-sk__blok--let');
    html += lijstHtml('Waarom deze keuze', r.waarom);
    html += lijstHtml('Goed om te weten', r.meldingen, 'so-sk__blok--let');
    if (r.alternatieven.length) {
      html += '<div class="so-sk__blok"><h3>Ook mogelijk</h3><ul>' + r.alternatieven.map((x) => '<li><strong>' + esc(x.label) + '</strong>: ' + esc(x.toelichting) + '</li>').join('') + '</ul></div>';
    }
    if (r.besparing) {
      html += r.besparing.soort === 'indicatie'
        ? '<div class="so-sk__blok"><h3>Besparing (indicatie)</h3><p class="so-sk__bedrag">€' + r.besparing.min.toLocaleString('nl-NL') + ' – €' + r.besparing.max.toLocaleString('nl-NL') + ' per jaar</p><details><summary>Hoe we dit rekenen</summary><ul>' + r.besparing.aannames.map((x) => '<li>' + esc(x) + '</li>').join('') + '</ul></details></div>'
        : '<div class="so-sk__blok"><h3>Besparing</h3><p>' + esc(r.besparing.tekst) + '</p></div>';
    }
    if (r.installatie) html += '<div class="so-sk__blok"><h3>Installatie</h3><p>' + esc(r.installatie.tekst) + '</p></div>';
    else html += '<p class="so-sk__klein">Liever laten installeren? In een deel van Nederland en België kan dat; vraag het ons.</p>';
    html += '<div class="so-sk__acties">' +
      (maatwerk ? '' : '<a class="button" href="' + esc(r.productUrl) + '" data-actie="naar-set">Bekijk deze set</a>') +
      '<button type="button" class="button ' + (maatwerk ? '' : 'button--secondary') + '" data-actie="advies-aanvragen">Vraag advies aan met deze gegevens</button>' +
      '<button type="button" class="so-sk__terug" data-actie="opnieuw">Antwoorden aanpassen</button></div>';
    html += '<p class="so-sk__klein">Op de productpagina staan deze keuzes alvast ingevuld. Daar zie je ook de prijs.</p>';
    el('[data-uitkomst-inhoud]').innerHTML = html;
    el('[data-stap]').hidden = true;
    el('[data-uitkomst]').hidden = false;
    el('[data-formulier]').hidden = !maatwerk;
    vulFormulier(r);
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    meet('so_systeemkeuze_uitkomst', { status: r.status, set: r.set.key, omvormer: c.omvormer && c.omvormer.key, accu: c.accu && c.accu.label, panelen: c.panelen && c.panelen.aantal, land: a.land });
  }

  function vulFormulier(r) {
    const c = r.config;
    const regels = [
      'Advies uit de systeemkeuze (' + r.versie + ')',
      'Status: ' + r.status + (r.maatwerkRedenen.length ? ' — ' + r.maatwerkRedenen.join(' ') : ''),
      'Set: ' + r.set.naam,
      c.omvormer ? 'Omvormer: ' + c.omvormer.label : '',
      c.accu ? 'Accu: ' + c.accu.label : '',
      c.panelen ? 'Panelen: ' + c.panelen.aantal + ' × ' + c.panelen.wp + ' Wp' : '',
      '',
      'Antwoorden:',
      JSON.stringify(a, null, 1),
    ].filter((x) => x !== null);
    const body = root.querySelector('[name="contact[body]"]');
    if (body) body.value = regels.join('\n');
  }

  root.addEventListener('click', (e) => {
    const t = e.target.closest('button, a');
    if (!t || !root.contains(t)) return;
    const lijst = zichtbaar();
    const v = lijst[stap];
    if (t.dataset.land) { a.land = t.dataset.land; delete a.gewest; bewaar(); zetLand(); renderVraag(); return; }
    if (t.dataset.w !== undefined && v) {
      const w = JSON.parse(t.dataset.w);
      if (v.soort === 'multi') {
        const set = new Set(a[v.id] || []);
        set.has(w) ? set.delete(w) : set.add(w);
        a[v.id] = Array.from(set);
        bewaar(); renderVraag();
      } else {
        if (w === null) delete a[v.id]; else a[v.id] = w;
        bewaar();
        stap++; renderVraag();
      }
      return;
    }
    if (t.dataset.huishouden) { a.huishouden = t.dataset.huishouden; bewaar(); renderVraag(); return; }
    if (t.dataset.pvfase !== undefined) { if (t.dataset.pvfase) a.bestaandePvFase = t.dataset.pvfase; else delete a.bestaandePvFase; bewaar(); renderVraag(); return; }
    if (t.dataset.orientatie) { a.orientatie = t.dataset.orientatie; bewaar(); renderVraag(); return; }
    const actie = t.dataset.actie;
    if (actie === 'verder') { stap++; renderVraag(); }
    else if (actie === 'terug') { stap--; renderVraag(); }
    else if (actie === 'advies') renderUitkomst();
    else if (actie === 'opnieuw') { stap = 0; renderVraag(); }
    else if (actie === 'advies-aanvragen') { el('[data-formulier]').hidden = false; el('[data-formulier]').scrollIntoView({ behavior: 'smooth' }); meet('so_systeemkeuze_advies_aanvragen', {}); }
    else if (actie === 'naar-set') meet('so_systeemkeuze_naar_set', { url: t.getAttribute('href') });
    else if (actie === 'liever-advies') {
      a.wilAdvies = true; bewaar();
      if (a.situatie) renderUitkomst();
      else { vulFormulier({ versie: C.versie, status: 'advies', maatwerkRedenen: [], set: { naam: 'nog niet gekozen' }, config: {} }); el('[data-formulier]').hidden = false; el('[data-formulier]').scrollIntoView({ behavior: 'smooth' }); }
      meet('so_systeemkeuze_liever_advies', { situatie: a.situatie || null });
    }
  });

  root.addEventListener('input', (e) => {
    const t = e.target;
    if (t.dataset.veld) { const n = parseFloat(t.value); if (n > 0) a[t.dataset.veld] = n; else delete a[t.dataset.veld]; bewaar(); }
    if (t.dataset.tekst) { a[t.dataset.tekst] = t.value; bewaar(); }
  });
  root.addEventListener('change', (e) => {
    const t = e.target;
    if (t.dataset.check) { a[t.dataset.check] = t.checked; bewaar(); renderVraag(); }
  });

  function zetLand() {
    root.querySelectorAll('[data-land]').forEach((b) => b.classList.toggle('is-actief', b.dataset.land === a.land));
  }

  zetLand();
  if (root.querySelector('[data-so-sk-verzonden]')) {
    el('[data-stap]').hidden = true;
    el('[data-bedankt]').hidden = false;
    meet('so_systeemkeuze_advies_verzonden', {});
  } else if (/[?&]uitkomst=1/.test(location.search) && a.situatie) {
    renderUitkomst();
  } else if (root.querySelector('[data-so-sk-fout]')) {
    renderUitkomst();
    el('[data-formulier]').hidden = false;
  } else {
    renderVraag();
  }
})();
